// extracted by mini-css-extract-plugin
module.exports = {"textAreaContainer":"styles_textAreaContainer__z_5Ai","fauxTextArea":"styles_fauxTextArea__GbMmU","fauxTextAreaInner":"styles_fauxTextAreaInner__pQwyH"};